<template>
   <div class="ThirdSectionContainer">
    <!-- 2 div left and right -->
    <div class="leftBox">
      <div class="imageContainer">
         <img class="leftBoxImage" :src="image" alt="image">
         <a type="button" class="signInBtn " href="https://us17.list-manage.com/contact-form?u=12eb10c034208fa73e5a394c1&form_id=3349a43f091cf8acd4ccbbef24d933e5" target="_blank"  style="text-decoration: none;color: white;">
        <Icon class="iconbtn" icon="fluent:arrow-right-24-regular" height="20" />
        Demander une démonstration
         </a>
      <Icon class="icon" icon="bi:play-btn" height="80" />
      </div>
    </div>
    <div class="rightBox">
      <div class="firstsection">
        <h1 class="title">
            Un suivi en temps réel de l'avancée de vos dossiers
        </h1>
      </div>
      <div class="secondsection">
        <div class="card">
          <div>
           <img :src="icon18" alt="icon18">
          </div>
          <div>
            <span class="titlecard">
              Suivi
            </span>
            <P class="detailcard">
                L'application Prexange vous permet de suivre en temps réel l'avancée de vos dossiers.
            </P>
          </div>
        </div>
        <div class="card">
          <div>
           <img :src="icon19" alt="icon18">
          </div>
          <div>
            <span class="titlecard">
              Proposition
            </span>
            <P class="detailcard">
              Déposez vos dossiers clients et recevez les propositions des partenaires bancaires.            </P>
          </div>
        </div>
        <div class="card">
          <div>
           <img :src="icon20" alt="icon18">
          </div>
          <div>
            <span class="titlecard">
              Pilotage
            </span>
            <P class="detailcard">
              Pilotez votre production en quelques clics seulement.            </P>
          </div>
        </div>
      </div>
    </div>
  </div>
  </template>
  
  <script>
  import icon18 from '@/assets/images/suivi.png';
  import icon19 from '@/assets/images/proposition.png';
  import icon20 from '@/assets/images/pilotage.png';
  import image from '@/assets/images/bg3sec.png';
  export default {
    name: "RealTimeTrackingSection",
    data() {
    return {
      icon18: icon18,
      icon19: icon19,
      icon20: icon20,
      image : image
     
    };
  }
  };
  </script>
  <style lang="scss">
  @import './thirdService.scss'
  
  </style>
  